/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileImageMetaData } from './StoreProfileImageMetaData';
import {
    StoreProfileImageMetaDataFromJSON,
    StoreProfileImageMetaDataFromJSONTyped,
    StoreProfileImageMetaDataToJSON,
    StoreProfileImageMetaDataToJSONTyped,
} from './StoreProfileImageMetaData';

/**
 * 
 * @export
 * @interface StoreProfileDetailsImages
 */
export interface StoreProfileDetailsImages {
    /**
     * 
     * @type {StoreProfileImageMetaData}
     * @memberof StoreProfileDetailsImages
     */
    header?: StoreProfileImageMetaData;
    /**
     * 
     * @type {StoreProfileImageMetaData}
     * @memberof StoreProfileDetailsImages
     */
    brand?: StoreProfileImageMetaData;
    /**
     * 
     * @type {Array<StoreProfileImageMetaData>}
     * @memberof StoreProfileDetailsImages
     */
    store?: Array<StoreProfileImageMetaData>;
}

/**
 * Check if a given object implements the StoreProfileDetailsImages interface.
 */
export function instanceOfStoreProfileDetailsImages(value: object): value is StoreProfileDetailsImages {
    return true;
}

export function StoreProfileDetailsImagesFromJSON(json: any): StoreProfileDetailsImages {
    return StoreProfileDetailsImagesFromJSONTyped(json, false);
}

export function StoreProfileDetailsImagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileDetailsImages {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'] == null ? undefined : StoreProfileImageMetaDataFromJSON(json['header']),
        'brand': json['brand'] == null ? undefined : StoreProfileImageMetaDataFromJSON(json['brand']),
        'store': json['store'] == null ? undefined : ((json['store'] as Array<any>).map(StoreProfileImageMetaDataFromJSON)),
    };
}

export function StoreProfileDetailsImagesToJSON(json: any): StoreProfileDetailsImages {
    return StoreProfileDetailsImagesToJSONTyped(json, false);
}

export function StoreProfileDetailsImagesToJSONTyped(value?: StoreProfileDetailsImages | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': StoreProfileImageMetaDataToJSON(value['header']),
        'brand': StoreProfileImageMetaDataToJSON(value['brand']),
        'store': value['store'] == null ? undefined : ((value['store'] as Array<any>).map(StoreProfileImageMetaDataToJSON)),
    };
}

